import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const MotionBox = motion(Box);
const MotionHeading = motion(Heading);
const MotionText = motion(Text);

const Footer = () => {
  const { ref, isInView } = useScrollAnimation({ once: true, margin: "-50px" });

  return (
    <Box
      as="footer"
      mt={{ base: 8, md: 16 }}
      py={{ base: 8, md: 12 }}
      bg={useColorModeValue("gray.50", "gray.800")}
      borderTopWidth="1px"
    >
      <Container maxW="6xl">
        <VStack align="stretch" spacing={4} ref={ref}>
          <MotionBox
            id="about"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.6 }}
          >
            <MotionHeading
              as="h2"
              size="md"
              mb={2}
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : { opacity: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              About SkillBack
            </MotionHeading>
            <MotionText
              fontSize="sm"
              color={useColorModeValue("gray.700", "gray.300")}
              lineHeight="taller"
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : { opacity: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              SkillBack integrates <strong>Subject matter expertise</strong> with recruiter
              heuristics to generate role-aware resumes. Using <strong>SME-trained models</strong> fine-tuned on job
              descriptions and industry corpora, it performs semantic parsing, entity extraction, and
              ranking to align experience with requirements across cloud, DevOps, AI/ML, security, and
              software engineering. Outputs are optimized for ATS compliance, keyword density, and
              measurable impact.
            </MotionText>
          </MotionBox>

          <Divider />

          <MotionText
            fontSize="xs"
            color={useColorModeValue("gray.600", "gray.400")}
            textAlign="center"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            © 2025 SkillBack. All Rights Reserved.
          </MotionText>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;